import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES } from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesAdvantages/utils/form';
import { PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES } from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDeliveryAndSupport/utils/form';
import {
  KEY_FEATURES_NAMES,
  PRODUCT_AND_SERVICES_ARRAY_NAMES,
  PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesDescription/utils/form';
import {
  PRODUCTS_AND_SERVICES_R_AND_D_NAMES,
  TIMELINE_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/ProductsAndServices/ProductAndServicesRAndD/utils/form';

import { ol, ul } from '../helpers';

const KEY_FEATURES_INSTRUCTIONS = {
  [KEY_FEATURES_NAMES.FEATURE]: {
    name: 'Характеристики продукту/послуги',
    instruction: 'Перерахуйте ключові характеристики продукту стисло, підкресливши його основні функції та переваги.',
    exampleOne: '',
    exampleTwo: '',
  },
  [KEY_FEATURES_NAMES.DESCRIPTION]: {
    name: 'Характеристики продукту/послуги',
    instruction:
      'Підкресліть інноваційні аспекти або технологічні досягнення, що вирізняють продукт на ринку. Чітко опишіть функціональність, специфікації та елементи дизайну, які формують його унікальність.',
    exampleOne: ol([
      'Потужність: розроблено для забезпечення стабільної роботи в складних умовах.',
      'Безперервна гусенична система: унікальна конструкція забезпечує відмінне зчеплення та плавність руху, особливо на важких або вологих ґрунтах.',
      'Запатентоване гумове покриття: мінімізує тиск на ґрунт і зменшує його ущільнення та пошкодження культур.',
    ]),
    exampleTwo: ol([
      'Точність: перекладацькі послуги та інструменти на базі AI забезпечують високу точність, зберігаючи зміст оригінального повідомлення різними мовами.',
      'Ефективність: завдяки передовим AI-технологіям компанія оптимізує процес перекладу, скорочуючи час виконання без втрати якості, що підвищує загальну продуктивність.',
    ]),
  },
};

const DEVELOPMENT_TIMELINE_INSTRUCTIONS = {
  [TIMELINE_ROW_NAMES.STAGE]: {
    name: 'Графік розробки',
    instruction:
      'Відповідаючи на запитання щодо термінів реалізації проєкту, дотримуйтеся таких кроків:' +
      ol([
        'Окресліть ключові етапи — від концепції до запуску.',
        'Укажіть орієнтовну тривалість кожного етапу.',
        'Позначте, на якому етапі ви перебуваєте зараз.',
      ]),
    exampleOne: ul([
      'Концепція та дизайн: 6 місяців.',
      'Прототипування та тестування: 9 місяців.',
      'Налаштування виробництва: 3 місяці.',
      'Маркетинг та підготовка до запуску: 2 місяці.',
      'Наразі на етапі налаштування виробництва.',
    ]),
    exampleTwo: ul([
      'Концептуальний етап: 3 місяці.',
      'Дизайн і прототипування: 6 місяців.',
      'Тестування та ітерації: 4 місяці.',
      'Фіналізація та виробництво: 3 місяці.',
      'Наразі на етапі тестування та ітерацій.',
    ]),
  },
};

const KEY_FEATURES_AND_BENEFITS_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: KEY_FEATURES_INSTRUCTIONS,
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.FILE]: {
    name: '',
    instruction:
      'Додайте високоякісне фото продукту/послуги. Переконайтеся, що зображення добре освітлене та зроблене професійно.',
    exampleOne: '',
    exampleTwo: '',
  },
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Назва продукту/послуги',
    instruction:
      'Вкажіть назву продукту чи послуги. Використовуйте чітку професійну термінологію, що найкраще описує вашу пропозицію.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const QUALITY_CERTIFICATIONS_DESCRIPTION_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Назва сертифікації якості',
    instruction: 'Надайте чіткий перелік релевантних сертифікацій, таких як ISO 9001 для управління якістю.',
    exampleOne: 'EcoGrain Certified',
    exampleTwo: 'EnviroCrop Certified',
  },

  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: {
    name: 'Опис сертифікацій якості',
    instruction:
      'Надайте чіткий перелік релевантних сертифікацій, таких як ISO 9001. Коротко поясніть значення кожної сертифікації та запропонуйте додаткові деталі за потреби.',
    exampleOne:
      'EcoGrain Certified гарантує, що зернові вирощені з використанням екологічно чистих практик: органічного землеробства, мінімального використання пестицидів та сталого управління водними ресурсами. Сертифікація підтверджує відповідність екологічним стандартам, сприяючи збереженню біорізноманіття.',
    exampleTwo:
      'EnviroCrop Certified підтверджує, що культури вирощено із дотриманням принципів екологічної сталості. Це гарантує, що застосовуються методи, такі як збереження ґрунтів, сівозміна та природні методи боротьби зі шкідниками, з мінімальним впливом на довкілля.',
  },
};

const PARENTS_OR_TRADEMARKS_DESCRIPTION_INSTRUCTIONS = {
  [PRODUCT_AND_SERVICES_ARRAY_NAMES.VALUE]: {
    name: 'Назва об’єкта інтелектуальної власності',
    instruction:
      'Надайте стислий перелік релевантних патентів і торговельних марок. Укажіть їхні назви, реєстраційні номери та короткий опис значення.',
    exampleOne: 'InnoGrainTM Technology',
    exampleTwo: 'SmartSeed Technology',
  },

  [PRODUCT_AND_SERVICES_ARRAY_NAMES.DESCRIPTION]: {
    name: 'Опис об’єкта інтелектуальної власності',
    instruction:
      'Надайте стислий перелік релевантних патентів і торговельних марок. Укажіть їхні назви, реєстраційні номери та коротко опишіть їхнє значення.',
    exampleOne:
      'InnoGrainTM Technology охоплює запатентовані процеси та інновації у селекції, вирощуванні та зберіганні зерна. Технологія забезпечує підвищену врожайність, стійкість до хвороб і покращену поживну цінність, захищаючи конкурентні переваги компанії.',
    exampleTwo:
      'SmartSeed Technology включає передові методики та генетичні інновації для створення високопродуктивних сортів насіння. Вони забезпечують стійкість до шкідників і хвороб, підвищену врожайність і кращу засвоюваність поживних речовин.',
  },
};

const DESCRIPTION_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PRODUCTS_OR_SERVICES_AND_THEIR_PURPOSE]: {
    name: 'Огляд продуктів/послуг',
    instruction:
      'Надайте структурований перелік ваших продуктів або послуг. Згрупуйте їх за категоріями або виділіть будь-які флагманські пропозиції, що визначають ваш бізнес. Підкресліть основні характеристики або якості, які відрізняють ваші продукти чи послуги від конкурентів, такі як інновації, якість або унікальні особливості.',
    exampleOne:
      'Компанія спеціалізується на виробництві потужних гусеничних тракторів, розроблених для важких або вологих ґрунтів. Продукція включає:' + 
      ol([
        'Гусеничні трактори',
        'Сільськогосподарську техніку',
        'Екологічні рішення'
      ]),

    exampleTwo:
      'Компанія пропонує низку продуктів і послуг, розроблених для оптимізації глобальної комунікації та процесів взаємодії. Пропозиції включають:' + 
      ol([
        'Послуги перекладу',
        'Інструменти перекладу на базі штучного інтелекту',
        'Рішення для оптимізації комунікації',
        'Інноваційні технологічні рішення'
      ]),
  },
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.KEY_FEATURES_AND_BENEFITS]: KEY_FEATURES_AND_BENEFITS_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_STANDARDS]: {
    name: 'Стандарти якості',
    instruction:
      'Укажіть, що ваші продукти/послуги відповідають світовим стандартам якості, таким як ISO 9001:2015, підкреслюючи послідовність і високий рівень якості. Коротко окресліть додаткові галузеві стандарти.',
    exampleOne:
      'Продукція компанії відповідає світовим стандартам якості, включно з ISO 9001:2015, що гарантує стабільність процесів і високу якість продукції. Додатково компанія дотримується стандартів ASTM International щодо матеріалів і тестування сільськогосподарської техніки.',
    exampleTwo:
      'Продукти та послуги компанії відповідають міжнародним стандартам якості, зокрема ISO 9001:2015. Компанія також дотримується галузевих норм, таких як ASTM F2575 для забезпечення якості перекладів.',
  },

  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.QUALITY_CERTIFICATIONS]: QUALITY_CERTIFICATIONS_DESCRIPTION_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_DESCRIPTION_NAMES.PATENTS_OR_TRADEMARKS]: PARENTS_OR_TRADEMARKS_DESCRIPTION_INSTRUCTIONS,
};

const ADVANTAGES_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_ADVANTAGES_NAMES.PRODUCT_VALUE]: {
    name: 'Цінність для клієнта',
    instruction:
      'Чітко визначте основну цінність продукту та проблему, яку він вирішує. Розкрийте переваги, які отримують клієнти, і поясніть, як продукт спрощує їхнє життя, економить час чи кошти або покращує досвід.',
    exampleOne:
      'Мінімізуючи ущільнення ґрунту та максимізуючи зчеплення, гусеничні трактори дають змогу фермерам працювати ефективніше, виконуючи завдання швидше та точніше.',
    exampleTwo:
      'Мовна платформа забезпечує безперешкодну комунікацію, дозволяючи клієнтам ефективно взаємодіяти з глобальною аудиторією та розширювати своє охоплення.',
  },
};

const R_AND_D_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.READINESS_LEVEL]: {
    name: 'Готовність до виробництва та впровадження',
    instruction:
      'Передайте прогрес стисло: "Повністю запущено" означає, що продукт/послуга вже доступні; "Фінальна фаза тестування" — завершення вже близько; "У розробці" — триває робота до готовності; "Концептуальний етап" — початкова стадія розробки.',
    exampleOne:
      'Гусеничні трактори повністю запущено у виробництво, доступні для купівлі та пройшли широке польове тестування, що підтвердило їхню ефективність і надійність.',
    exampleTwo: 'Мобільний перекладацький застосунок перебуває в розробці, запуск очікується за шість місяців.',
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.CONDUCTED_ACTIVITIES]: {
    name: 'Прогрес R&D',
    instruction:
      'Надайте стислий огляд:' +
      ol([
        'Опишіть ключові напрями досліджень та їхні цілі.',
        'Зазначте результати, прориви чи інновації.',
        'Запропонуйте надати детальні звіти за запитом.',
      ]),
    exampleOne:
      'R&D було спрямовано на підвищення ефективності тракторів, зменшення впливу на довкілля та покращення здоров’я ґрунту. Проривом стала запатентована конструкція безперервної гусениці. Детальні звіти доступні за запитом.',
    exampleTwo:
      'R&D зосереджено на підвищенні точності перекладу та швидкості роботи AI-алгоритмів. Прорив: збільшення ефективності перекладу на 20%. Детальні звіти доступні за запитом.',
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.TIMELINES]: DEVELOPMENT_TIMELINE_INSTRUCTIONS,
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.RESOURCES]: {
    name: 'Необхідні ресурси',
    instruction:
      'Надайте повний огляд ключових ресурсів, необхідних для успішної розробки продукту чи послуги. Класифікуйте їх на технічні, фінансові, людські та інші.',
    exampleOne:
      'Ключові ресурси включають:' +
      ol([
        'Технічні: сучасне виробниче обладнання, програмне забезпечення для проєктування та моделювання.',
        'Фінансові: фінансування для R&D, запуску виробництва та маркетингу.',
        'Людські: інженери, техніки, маркетологи.',
        'Інші: регуляторні дозволи, партнерства в ланцюгу постачання.',
      ]),
    exampleTwo: ol([
      'Технічні: інструменти для розробки ПЗ, AI-алгоритми',
      'Фінансові: фінансування досліджень, закупівлі обладнання',
      'Людські: розробники ПЗ, AI-спеціалісти',
      'Інші: дані маркетингових досліджень, юридична підтримка',
    ]),
  },
  [PRODUCTS_AND_SERVICES_R_AND_D_NAMES.WEAKNESSES]: {
    name: 'Недоліки продукту та способи їх усунення',
    instruction:
      'Визнайте недоліки або проблеми поточної версії продукту. Покажіть, що ви врахували відгуки клієнтів або галузеві вимоги. Детально опишіть стратегії та строки усунення недоліків.',
    exampleOne:
      'Компанія працює над підвищенням паливної ефективності тракторів шляхом оптимізації роботи двигуна та аеродинаміки. Мета — впровадити покращення протягом наступного року.',
    exampleTwo:
      'Компанія визнає зауваження користувачів щодо епізодичної неточності перекладів. Команда вдосконалює AI-алгоритми для підвищення точності на 15% протягом найближчих трьох місяців.',
  },
};

const DELIVERY_AND_SUPPORT_INSTRUCTIONS = {
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS]: {
    name: 'Логістика та доставка',
    instruction:
      'Опишіть процес доставки, підкресліть партнерства з перевізниками або центрами виконання замовлень. Зазначте стратегії швидкого вирішення проблем із доставкою.',
    exampleOne:
      'Компанія співпрацює з надійними перевізниками для глобальної доставки. Замовлення обробляються оперативно, доступне відстеження в режимі реального часу. Повернення товарів здійснюється за спрощеною процедурою.',
    exampleTwo:
      'Компанія партнерствує з перевіреними перевізниками для міжнародної доставки. Замовлення обробляються протягом 24 годин, доступне відстеження. Повернення оформлюються легко завдяки підтримці клієнтів.',
  },
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE]: {
    name: 'Підтримка та сервіс після покупки',
    instruction:
      'Надайте стислий огляд сервісної підтримки. Підкресліть доступні види допомоги: технічна підтримка, інструкції з усунення несправностей, ремонтні послуги. Укажіть канали доступу до підтримки: онлайн-ресурси, гарячі лінії, сервісні центри.',
    exampleOne:
      'Компанія надає комплексну підтримку після покупки, включно з технічною допомогою, гайдами з усунення несправностей і ремонтними послугами. Підтримка доступна через онлайн-ресурси, гарячі лінії та сервісні центри.',
    exampleTwo:
      'Компанія пропонує цілодобову технічну підтримку, інструкції з усунення несправностей та ремонтні сервіси. Клієнти можуть звертатися через онлайн-ресурси, гарячі лінії або сервісні центри по всьому світу.',
  },
  [PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY]: {
    name: 'Гарантія та програми повернення',
    instruction:
      'Чітко опишіть гарантійні умови: тривалість, покриття, обмеження. Опишіть процес повернення: критерії, терміни, порядок подання заявки.',
    exampleOne:
      'Продукція має річну гарантію на виробничі дефекти. Повернення приймаються протягом 30 днів за умови збереження початкового стану товару.',
    exampleTwo:
      'Мовна платформа пропонує гарантію: користувач може отримати повне відшкодування протягом 30 днів у разі незадоволення сервісом. Також надається 12-місячна гарантія на технічні збої.',
  },
};

export const PRODUCTS_AND_SERVICES_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DESCRIPTION]: DESCRIPTION_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.ADVANTAGES]: ADVANTAGES_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.R_AND_D]: R_AND_D_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT]: DELIVERY_AND_SUPPORT_INSTRUCTIONS,
};
